import React, { useEffect } from "react"

import { connect } from "react-redux"
import { Container } from "reactstrap";
import withRouter from 'components/Common/withRouter';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  changeColor,
  showRightSidebarAction,
  changeMode
} from "../../store/actions"

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import Rightbar from "../CommonForBoth/Rightbar"
//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"
import { syncAuthUserFromApi } from "../../helpers/auth_api"

interface VerticalLayoutProps {
  children?: React.ReactNode
  leftSideBarTheme?: string
  leftSideBarType?: string
  isMobile?: boolean
  showRightSidebar?: boolean
  changeLayoutWidth?: (width: string) => void
  changeColor?: (color: string) => void
  changeMode?: (mode: string) => void
  changeSidebarTheme?: (theme: string) => void
  changeSidebarType?: (type: string, isMobile?: boolean) => void
  changeTopbarTheme?: (theme: string) => void
}

const Layout: React.FC<VerticalLayoutProps> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const selectLayoutState = (state: any) => state.Layout;

  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftSideBarTheme: layout.leftSideBarTheme,
      layoutWidth: layout.layoutWidth,
      leftSideBarType: layout.leftSideBarType,
      topbarTheme: layout.topbarTheme,
      layoutColor: layout.layoutColor,
      layoutMode:layout.layoutMode
    }));

  const {
    leftSideBarTheme,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    layoutColor,
    layoutMode
  } = useSelector(selectLayoutProperties);

  useEffect(() => {
    const hideRightbar = (event: MouseEvent) => {
      var rightbar = document.getElementById("right-bar");
      //if clicked in inside right bar, then do nothing
      if (rightbar && event.target && rightbar.contains(event.target as Node)) {
        return;
      } else {
        //if clicked in outside of rightbar then fire action for hide rightbar
        dispatch(showRightSidebarAction(false));
      }
    };
  
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);
  
    // Cleanup the event listener on component unmount
    return () => {
      document.body.removeEventListener("click", hideRightbar, true);
    };
  }, [dispatch]); 

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    syncAuthUserFromApi()
    const onFocus = () => {
      syncAuthUserFromApi()
    }
    window.addEventListener("focus", onFocus)
    return () => window.removeEventListener("focus", onFocus)
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (layoutMode) {
      dispatch(changeMode(layoutMode));
    }
  }, [layoutMode, dispatch]);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType, isMobile));
    }
  }, [leftSideBarType, dispatch, isMobile]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  useEffect(() => {
    if (layoutColor) {
      dispatch(changeColor(layoutColor));
    }
  }, [layoutColor, dispatch]);

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };


  return (
    <React.Fragment>
      {/* <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
            <div className="chase-dot"></div>
          </div>
        </div>
      </div> */}

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={props.leftSideBarTheme}
          type={props.leftSideBarType}
          isMobile={props.isMobile}
          router={{ location, navigate, params }}
        />
        <div className="main-content">
          <div className="page-content">
            <Container fluid>
              {location.pathname !== "/profile" && <Breadcrumb />}
              {props.children}
              {/* render Footer */}
              <Footer />
            </Container>
          </div>
        </div>
        <Footer />
      </div>
      {props.showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  )
}

const mapStatetoProps = (state: any) => {
  return {
    ...state.Layout,
  }
}

const VerticalLayoutWithRouter = connect(mapStatetoProps, {
  changeLayout,
  changeColor,
  changeMode,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout)) as React.ComponentType<{ children?: React.ReactNode }>

export default VerticalLayoutWithRouter
